var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.633,
    height: 65.626,
    viewBox: "0 0 65.633 65.626",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trophy_1_",
    "data-name": "trophy (1)",
    transform: "translate(0 -0.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2302",
    "data-name": "Group 2302",
    transform: "translate(0 0.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2301",
    "data-name": "Group 2301",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5122",
    "data-name": "Path 5122",
    d: "M65.63,12.548c-.065-5.57-2.916-8.638-8.027-8.638a18.027,18.027,0,0,0-5.13.845C52.6,2.477,52.6,1.072,52.6,1V.027H13.034V1c0,.033,0,1.461.129,3.753a18.028,18.028,0,0,0-5.134-.846C2.918,3.909.067,6.977,0,12.548a26.757,26.757,0,0,0,3.715,14.5A23.457,23.457,0,0,0,11.6,34.9a18.432,18.432,0,0,0,9.487,2.6,16.337,16.337,0,0,0,1.667-.082l.1-.011a15.018,15.018,0,0,0,3.687,2.946,3.838,3.838,0,0,1,1.874,2.561,3.211,3.211,0,0,0,.089,6.159v4.09H23.229v4.269h-5.2v8.225H47.608V57.427H42.4V53.158H37.13v-4.09a3.211,3.211,0,0,0,.089-6.159,3.838,3.838,0,0,1,1.874-2.561A15.082,15.082,0,0,0,42.782,37.4a16.142,16.142,0,0,0,1.765.092h0a18.432,18.432,0,0,0,9.486-2.6,23.459,23.459,0,0,0,7.882-7.854A26.754,26.754,0,0,0,65.63,12.548Zm-15-10.571c-.009.356-.023.8-.044,1.329H15.047c-.022-.524-.037-.973-.046-1.329Zm1.326,8.949a15.354,15.354,0,0,1,4.565-.883,3.508,3.508,0,0,1,2.751.933c.621.712.821,1.908.594,3.555-.943,6.861-3.918,12.217-8.378,15.081a10.58,10.58,0,0,1-4.629,1.556C49.829,24.934,51.265,17.113,51.959,10.925ZM14.677,17.715a55.966,55.966,0,0,0,3.934,13.125c.051.111.1.22.155.329a10.582,10.582,0,0,1-4.627-1.556C9.68,26.749,6.7,21.393,5.762,14.532c-.226-1.647-.026-2.843.595-3.555a3.508,3.508,0,0,1,2.751-.933,15.364,15.364,0,0,1,4.569.884C13.912,13.037,14.235,15.347,14.677,17.715Zm6.409,17.832A16.482,16.482,0,0,1,12.6,33.231C9.351,31.273,1.8,25.342,1.951,12.571,2,8.054,3.992,5.859,8.029,5.859a16.886,16.886,0,0,1,5.266.994c.049.654.1,1.31.163,1.963a16.008,16.008,0,0,0-4.35-.722,5.325,5.325,0,0,0-4.221,1.6C3.88,10.85,3.524,12.567,3.831,14.8A27.452,27.452,0,0,0,7.09,24.832a18.457,18.457,0,0,0,6,6.42,12.962,12.962,0,0,0,6.728,1.933l.019.032q.15.262.3.516l.1.158c.1.159.195.317.294.472.037.058.075.115.112.173q.1.155.2.307t.2.291q.1.141.2.28c.031.043.061.088.092.131Zm24.574,23.83V63.7H19.974V59.377H45.659ZM37.13,55.108h3.324v2.319H25.178V55.108H37.13Zm-6.678-1.949V49.187H35.18v3.972Zm7.075-7.183a1.263,1.263,0,0,1-1.262,1.262h-6.9a1.262,1.262,0,1,1,0-2.523h6.9A1.263,1.263,0,0,1,37.528,45.976ZM42.4,34.833l-.032.042c-.1.124-.193.245-.29.364l-.071.088q-.16.195-.323.38l-.015.018a13.413,13.413,0,0,1-3.527,2.919,5.8,5.8,0,0,0-2.884,4.12H30.372a5.8,5.8,0,0,0-2.884-4.12A13.205,13.205,0,0,1,24.2,36l-.238-.272a21.8,21.8,0,0,1-2.715-3.98l-.255-.471c-4.191-8.1-5.459-19.8-5.841-26.021H50.491c-.016.27-.034.55-.054.84l0,.041q-.032.471-.069.945l0,.028c-.078,1-.17,2-.275,3l-.064.6c-.708,6.349-2.2,14.437-5.358,20.53l-.279.514A23.313,23.313,0,0,1,42.4,34.833Zm10.625-1.6a16.48,16.48,0,0,1-8.481,2.316h0l-.242,0,0-.006q.19-.262.374-.531l.045-.066q.156-.229.307-.464l.078-.121c.112-.175.222-.352.331-.532l.051-.085q.133-.223.263-.45l.062-.1a12.962,12.962,0,0,0,6.728-1.933,18.462,18.462,0,0,0,6-6.42A27.457,27.457,0,0,0,61.8,14.8c.306-2.23-.049-3.946-1.057-5.1a5.325,5.325,0,0,0-4.221-1.6,16,16,0,0,0-4.35.722c.061-.666.114-1.3.159-1.912l0-.051A16.885,16.885,0,0,1,57.6,5.859c4.037,0,6.025,2.2,6.078,6.712C63.83,25.342,56.281,31.273,53.028,33.231Z",
    transform: "translate(0 -0.027)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2304",
    "data-name": "Group 2304",
    transform: "translate(23.029 31.588)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2303",
    "data-name": "Group 2303"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5123",
    "data-name": "Path 5123",
    d: "M181.284,246.237l-1.628,1.073a17.347,17.347,0,0,0,1.776,2.279l1.426-1.329A15.394,15.394,0,0,1,181.284,246.237Z",
    transform: "translate(-179.656 -246.237)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2306",
    "data-name": "Group 2306",
    transform: "translate(18.573 20.78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2305",
    "data-name": "Group 2305"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5124",
    "data-name": "Path 5124",
    d: "M146.791,161.922l-1.9.434a37.98,37.98,0,0,0,3.709,10.224l1.695-.963A36.073,36.073,0,0,1,146.791,161.922Z",
    transform: "translate(-144.89 -161.922)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2308",
    "data-name": "Group 2308",
    transform: "translate(51.631 39.182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2307",
    "data-name": "Group 2307"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5125",
    "data-name": "Path 5125",
    d: "M408.016,309.067v-1.949h-1.646v-1.646h-1.949v1.646h-1.646v1.949h1.646v1.645h1.949v-1.646Z",
    transform: "translate(-402.774 -305.473)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2310",
    "data-name": "Group 2310",
    transform: "translate(9.744 49.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2309",
    "data-name": "Group 2309"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5126",
    "data-name": "Path 5126",
    d: "M80.729,389.835l0-1.949H79.346v-1.381l-1.949,0v1.381H76.016l0,1.949H77.4v1.381l1.949,0v-1.381Z",
    transform: "translate(-76.016 -386.506)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2312",
    "data-name": "Group 2312",
    transform: "translate(6.261 36.962)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2311",
    "data-name": "Group 2311"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2629",
    "data-name": "Rectangle 2629",
    width: 1.839,
    height: 1.949,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2314",
    "data-name": "Group 2314",
    transform: "translate(18.079 42.73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2313",
    "data-name": "Group 2313"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2630",
    "data-name": "Rectangle 2630",
    width: 1.839,
    height: 1.949,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2316",
    "data-name": "Group 2316",
    transform: "translate(47.718 48.595)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2315",
    "data-name": "Group 2315"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2631",
    "data-name": "Rectangle 2631",
    width: 1.839,
    height: 1.949,
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.e3c4296b54d169aa3301f288637b662f.svg";
export { ForwardRef as ReactComponent };